/* ============================================================
   Refurbished Product Section — Behavior
   File: assets/refurbished-product.js
   ============================================================ */

(function () {
  'use strict';

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents); } catch (e) {}
    }
    return '£' + (cents / 100).toFixed(2);
  }

  /* ===================== VARIANT SELECTOR ===================== */
  function initVariantSelector(section) {
    var selects = section.querySelectorAll('[data-rp-option]');
    var variantInput = section.querySelector('[name="id"]');
    var priceEl = section.querySelector('[data-rp-price]');
    var compareEl = section.querySelector('[data-rp-compare]');
    var savingsEl = section.querySelector('[data-rp-savings]');
    var productData = section.querySelector('[data-rp-product-json]');
    if (!variantInput || !productData) return;

    var product;
    try { product = JSON.parse(productData.textContent); } catch (e) { return; }

    function getSelectedOptions() {
      var opts = {};
      selects.forEach(function(el) { opts[el.dataset.rpOption] = el.value; });
      return opts;
    }

    function findVariant(opts) {
      return product.variants.find(function(v) {
        return v.options.every(function(o, i) {
          return o === opts['option' + (i + 1)];
        });
      });
    }

    function updatePrice(variant) {
      if (!priceEl) return;
      var addonTotal = 0;
      section.querySelectorAll('.rp-addon-checkbox:checked').forEach(function(cb) {
        if (cb.dataset.addonPrice) addonTotal += parseInt(cb.dataset.addonPrice);
      });
      priceEl.textContent = formatMoney(variant.price + addonTotal);
      priceEl.dataset.basePrice = variant.price;

      if (compareEl) {
        if (variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.removeAttribute('hidden');
        } else {
          compareEl.textContent = '';
          compareEl.setAttribute('hidden', '');
        }
      }
      if (savingsEl) {
        if (variant.compare_at_price > variant.price) {
          var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          savingsEl.textContent = 'Save ' + pct + '%';
          savingsEl.removeAttribute('hidden');
        } else {
          savingsEl.textContent = '';
          savingsEl.setAttribute('hidden', '');
        }
      }
      updateRPAmounts();
    }

    selects.forEach(function(el) {
      el.addEventListener('change', function() {
        var variant = findVariant(getSelectedOptions());
        if (variant) {
          variantInput.value = variant.id;
          updatePrice(variant);
        }
      });
    });
  }

  /* ===================== DYNAMIC CASE ADD-ON ===================== */
var CASE_VARIANTS = {
  'iphone 17 pro max': { variantId: 65541610897757 },
  'iphone 17 pro':     { variantId: 65541610897757 },
  'iphone 17 air':     { variantId: 65541610897757 },
  'iphone 17':         { variantId: 65541610897757 },
  'iphone 16 pro max': { variantId: 65543664435549 },
  'iphone 16 pro':     { variantId: 65543663321437 },
  'iphone 16 plus':    { variantId: 65541610897757 },
  'iphone 16':         { variantId: 65541610897757 },
  'iphone 15 pro max': { variantId: 65543590019421 },
  'iphone 15 pro':     { variantId: 65543590019421 },
  'iphone 15 plus':    { variantId: 65543389708637 },
  'iphone 15':         { variantId: 65543389708637 },
  'iphone 14 pro max': { variantId: 65543590019421 },
  'iphone 14 pro':     { variantId: 65543590019421 },
  'iphone 14 plus':    { variantId: 65543389708637 },
  'iphone 14':         { variantId: 65543389708637 },
  'iphone 13 pro max': { variantId: 65541610897757 },
  'iphone 13 pro':     { variantId: 65541610897757 },
  'iphone 13':         { variantId: 65543389708637 },
  'iphone 12 pro max': { variantId: 65541610897757 },
  'iphone 12 pro':     { variantId: 65541610897757 },
  'iphone 12':         { variantId: 65541610897757 },
  'iphone 11 pro max': { variantId: 65541610897757 },
  'iphone 11 pro':     { variantId: 65541610897757 },
  'iphone 11':         { variantId: 65541610897757 }
};

function getCaseVariant() {
  var title = (document.querySelector('.rp-title, h1, [data-rp-title]') || {}).textContent || '';
  title = title.toLowerCase();
  for (var model in CASE_VARIANTS) {
    if (title.indexOf(model) !== -1) return CASE_VARIANTS[model];
  }
  return null;
}
  /* ===================== QUANTITY BUTTONS ===================== */
  function initQuantity(section) {
    var minus = section.querySelector('[data-rp-qty-minus]');
    var plus = section.querySelector('[data-rp-qty-plus]');
    var input = section.querySelector('[data-rp-qty]');
    if (!minus || !plus || !input) return;
    minus.addEventListener('click', function() {
      var v = parseInt(input.value) || 1;
      if (v > 1) input.value = v - 1;
    });
    plus.addEventListener('click', function() {
      input.value = (parseInt(input.value) || 1) + 1;
    });
  }

  /* ===================== IMAGE THUMBNAILS ===================== */
  function initThumbnails(section) {
    var thumbs = section.querySelectorAll('[data-rp-thumb]');
    var mainImg = section.querySelector('[data-rp-main-img]');
    if (!thumbs.length || !mainImg) return;
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        mainImg.src = thumb.dataset.rpThumb;
        thumbs.forEach(function(t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ===================== FAQ ACCORDION ===================== */
const faqItems = document.querySelectorAll('.rp-faq__item');
faqItems.forEach(item => {
  const questionBtn = item.querySelector('.rp-faq__question');
  if (questionBtn) {
    questionBtn.addEventListener('click', () => {
      const isOpen = item.classList.contains('is-open');
      
      faqItems.forEach(el => {
        el.classList.remove('is-open');
        const btn = el.querySelector('.rp-faq__question');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
      
      if (!isOpen) {
        item.classList.add('is-open');
        questionBtn.setAttribute('aria-expanded', 'true');
      }
    });
  }
});

/* ===================== MOBILE FAQ VIEW ALL TOGGLE ===================== */
document.addEventListener('DOMContentLoaded', function() {
  var toggleBtn = document.querySelector('.rp-faq-mobile-toggle');
  var faqWrap = document.querySelector('.rp-faq-mobile-wrap');
  
  if (toggleBtn && faqWrap) {
    toggleBtn.addEventListener('click', function() {
      var isOpen = faqWrap.classList.toggle('is-open');
      toggleBtn.textContent = isOpen ? 'Hide FAQs' : 'View all FAQs';
    });
  }
});

  /* ===================== ADD-ON PRICE DISPLAY ===================== */
  function initAddonPricing(section) {
    var addonCheckboxes = section.querySelectorAll('.rp-addon-checkbox');
    var priceEl = section.querySelector('[data-rp-price]');
    if (!addonCheckboxes.length || !priceEl) return;

    function updateTotal() {
      var basePrice = parseInt(priceEl.dataset.basePrice || 0);
      var addonTotal = 0;
      addonCheckboxes.forEach(function(cb) {
        if (cb.checked && cb.dataset.addonPrice) {
          addonTotal += parseInt(cb.dataset.addonPrice);
        }
      });
      // Also include battery if checked
      var batteryCheckbox = section.querySelector('.rp-addon-battery-checkbox');
      if (batteryCheckbox && batteryCheckbox.checked) {
        var bv = getBatteryVariant();
        if (bv) addonTotal += bv.price;
      }
      priceEl.textContent = formatMoney(basePrice + addonTotal);
      updateRPAmounts();
    }

    addonCheckboxes.forEach(function(cb) {
      cb.addEventListener('change', updateTotal);
    });
  }

/* ===================== STICKY ATC ===================== */
  function initStickyAtc(section) {
    var sticky = section.querySelector('[data-rp-sticky]');
    var atcBtn = section.querySelector('[data-rp-atc]');
    var stickyBtn = section.querySelector('[data-rp-sticky-btn]');
    var stickyPriceEl = section.querySelector('[data-rp-sticky-price]');
    var form = section.querySelector('.rp-form');
    if (!sticky || !atcBtn || !form) return;

    function calcTotal() {
      var priceEl = section.querySelector('[data-rp-price]');
      var basePrice = parseInt(priceEl ? priceEl.dataset.basePrice || 0 : 0);
      var addonTotal = 0;
      section.querySelectorAll('.rp-addon-checkbox:checked').forEach(function(cb) {
        if (cb.dataset.addonPrice) addonTotal += parseInt(cb.dataset.addonPrice);
      });
      var batteryCheckbox = section.querySelector('.rp-addon-battery-checkbox');
      if (batteryCheckbox && batteryCheckbox.checked) {
        var bv = getBatteryVariant();
        if (bv) addonTotal += bv.price;
      }
      return basePrice + addonTotal;
    }

    function updateAllPrices() {
      var total = calcTotal();
      var formatted = formatMoney(total);
      var priceEl = section.querySelector('[data-rp-price]');
      if (priceEl) priceEl.textContent = formatted;
      if (stickyPriceEl) stickyPriceEl.textContent = formatted;
      updateRPAmounts();
    }

    section.querySelectorAll('.rp-addon-checkbox, .rp-addon-battery-checkbox').forEach(function(cb) {
      cb.addEventListener('change', updateAllPrices);
    });

    async function handleAtcClick(e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var variantInput = form.querySelector('[name="id"]');
      if (!variantInput || !variantInput.value) {
        alert('Please select a variant.');
        return;
      }

      var properties = {};
      var tradeInput = form.querySelector('.trade-hidden-input');
      if (tradeInput && tradeInput.value) properties['Trade-in'] = tradeInput.value;

      var qtyInput = form.querySelector('[data-rp-qty]');
      var qty = qtyInput ? (parseInt(qtyInput.value) || 1) : 1;

      var items = [{
        id: parseInt(variantInput.value),
        quantity: qty,
        properties: properties
      }];

      // --- DYNAMIC ACCESSORY LOOP INTEGRATED HERE ---
      section.querySelectorAll('.rp-addon-checkbox:checked').forEach(function(cb) {
        if (cb.value === 'Shockproof Case') {
          var cv = getCaseVariant();
          if (cv) {
            items.push({ id: cv.variantId, quantity: 1 });
          }
        } else if (cb.dataset.addonVariantId) {
          items.push({ id: parseInt(cb.dataset.addonVariantId), quantity: 1 });
        }
      });

      var batteryCheckbox = section.querySelector('.rp-addon-battery-checkbox');
      if (batteryCheckbox && batteryCheckbox.checked) {
        var bv = getBatteryVariant();
        if (bv) items.push({ id: bv.variantId, quantity: 1 });
      }

      [atcBtn, stickyBtn].forEach(function(btn) {
        if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
      });

      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        if (res.ok) {
          window.location.href = '/cart';
        } else {
          var err = await res.json();
          alert(err.description || 'Could not add to cart.');
          [atcBtn, stickyBtn].forEach(function(btn) {
            if (btn) { btn.disabled = false; btn.textContent = 'Add to cart'; }
          });
        }
      } catch (err) {
        console.error('Cart error:', err);
        [atcBtn, stickyBtn].forEach(function(btn) {
          if (btn) { btn.disabled = false; btn.textContent = 'Add to cart'; }
        });
      }
    }

    atcBtn.addEventListener('click', handleAtcClick);
    if (stickyBtn) stickyBtn.addEventListener('click', handleAtcClick);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          sticky.classList.toggle('is-visible', !entry.isIntersecting);
          sticky.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
        });
      }, { threshold: 0, rootMargin: '0px 0px -50px 0px' }).observe(atcBtn);
    } else {
      window.addEventListener('scroll', function() {
        sticky.classList.toggle('is-visible', atcBtn.getBoundingClientRect().bottom < 0);
      }, { passive: true });
    }
  }
  /* ===================== SECTION INIT ===================== */
  function initSection(section) {
    initVariantSelector(section);
    initQuantity(section);
    initThumbnails(section);
    initFaq(section);
  }

  /* ===================== YOTPO ROUTER ===================== */
  function initYotpoRouter() {
    document.body.addEventListener('click', function(event) {
      if (event.target.closest('.yotpo.bottomLine')) {
        event.preventDefault();
        var anchor = document.getElementById('rp-yotpo-reviews-anchor');
        if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  /* ===================== BOOT ===================== */
  function boot() {
    document.querySelectorAll('.rp-section').forEach(function(section) {
      initSection(section);
      initStickyAtc(section);
      initAddonPricing(section);
    });
    initYotpoRouter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();

/* ===================== READ MORE TOGGLE ===================== */
document.addEventListener('DOMContentLoaded', function() {
  var overview = document.querySelector('.rp-product-overview');
  var toggle = document.querySelector('.rp-overview-toggle');
  if (!overview || !toggle) return;
  toggle.addEventListener('click', function() {
    var expanded = overview.classList.toggle('is-expanded');
    toggle.textContent = expanded ? 'Read less' : 'Read more';
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  });
});

document.addEventListener('DOMContentLoaded', function() {
  var button = document.querySelector('.rp-faq-mobile-toggle');
  var content = document.querySelector('.rp-faq-mobile-wrap');
  if (!button || !content) return;
  button.addEventListener('click', function() {
    var isOpen = content.classList.toggle('is-open');
    button.textContent = isOpen ? 'Hide FAQs' : 'View all FAQs';
  });
});


/* ===================== PAYPAL / KLARNA INSTALLMENT AMOUNTS ===================== */
function updateRPAmounts() {
  var priceEl = document.querySelector('[data-rp-price]');
  if (!priceEl) return;
  var priceText = priceEl.textContent.replace(/[^0-9.]/g, '');
  var price = parseFloat(priceText);
  if (!price || isNaN(price)) return;
  var amount = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(price / 3);
  document.querySelectorAll('[data-rp-installment-amount]').forEach(function(el) {
    el.textContent = amount;
  });
}



/* ===================== MODAL OPEN / CLOSE ===================== */
  document.addEventListener('click', function(e) {
    var openBtn = e.target.closest('[data-rp-modal-open]');
    var closeBtn = e.target.closest('[data-rp-modal-close]');
    
    // UNBREAKABLE: Detects if the click lands outside of the popup content box
    var clickedOutside = e.target.closest('.rp-modal') && !e.target.closest('.rp-modal__box');
    
    if (openBtn) {
      e.preventDefault();
      e.stopPropagation();
      var modal = document.getElementById(openBtn.dataset.rpModalOpen);
      if (modal) {
        modal.classList.add('is-open');
      }
    }
    
    if (closeBtn || clickedOutside) {
      e.preventDefault();
      e.stopPropagation();
      
      var modalToClose = e.target.closest('.rp-modal');
      if (modalToClose) {
        modalToClose.classList.remove('is-open');
      }
    }
  });

/* ===================== DYNAMIC BATTERY ADD-ON ===================== */
var BATTERY_VARIANTS = {
  'iphone 17 pro max': { variantId: 65121555939677, price: 7999 },
  'iphone 17 pro':     { variantId: 65121555906909, price: 7999 },
  'iphone 17 air':     { variantId: 65121555874141, price: 7999 },
  'iphone 17':         { variantId: 65121555841373, price: 7999 },
  'iphone 16 pro max': { variantId: 65121555808605, price: 6999 },
  'iphone 16 pro':     { variantId: 65121555775837, price: 6999 },
  'iphone 16 plus':    { variantId: 65121555743069, price: 6999 },
  'iphone 16':         { variantId: 65121555710301, price: 6999 },
  'iphone 15 pro max': { variantId: 65121555677533, price: 6999 },
  'iphone 15 pro':     { variantId: 65121555644765, price: 6999 },
  'iphone 15 plus':    { variantId: 65121555611997, price: 6999 },
  'iphone 15':         { variantId: 65121555579229, price: 6999 },
  'iphone 14 pro max': { variantId: 65121555546461, price: 6999 },
  'iphone 14 pro':     { variantId: 65121555513693, price: 6999 },
  'iphone 14 plus':    { variantId: 65121555480925, price: 6999 },
  'iphone 14':         { variantId: 65121555448157, price: 6999 },
  'iphone 13 pro max': { variantId: 65121555415389, price: 5999 },
  'iphone 13 pro':     { variantId: 65121555382621, price: 5999 },
  'iphone 13':         { variantId: 65099063525725, price: 5999 },
  'iphone 12 pro max': { variantId: 65121507541341, price: 5999 },
  'iphone 12 pro':     { variantId: 65099063492957, price: 5999 },
  'iphone 12':         { variantId: 65099063460189, price: 5999 },
  'iphone 11 pro max': { variantId: 65121507508573, price: 4999 },
  'iphone 11 pro':     { variantId: 65099063394653, price: 4999 },
  'iphone 11':         { variantId: 65099063361885, price: 4999 },
};

function getBatteryVariant() {
  var title = (document.querySelector('.rp-title, h1, [data-rp-title]') || {}).textContent || '';
  title = title.toLowerCase();
  for (var model in BATTERY_VARIANTS) {
    if (title.indexOf(model) !== -1) return BATTERY_VARIANTS[model];
  }
  return null;
}

document.addEventListener('DOMContentLoaded', function() {
  var batteryCheckbox = document.querySelector('.rp-addon-battery-checkbox');
  var batteryPriceEl  = document.querySelector('.rp-battery-price');
  var priceEl         = document.querySelector('[data-rp-price]');
  var stickyPriceEl   = document.querySelector('[data-rp-sticky-price]');

  if (!batteryCheckbox) return;

  var variant = getBatteryVariant();

  if (variant && batteryPriceEl) {
    batteryPriceEl.textContent = '+£' + (variant.price / 100).toFixed(2);
  } else if (batteryPriceEl) {
    batteryPriceEl.textContent = 'Not available for this model';
    batteryCheckbox.disabled = true;
  }

  batteryCheckbox.addEventListener('change', function() {
    if (!priceEl) return;
    var basePrice  = parseInt(priceEl.dataset.basePrice || 0);
    var addonTotal = 0;
    document.querySelectorAll('.rp-addon-checkbox:checked').forEach(function(cb) {
      if (cb.dataset.addonPrice) addonTotal += parseInt(cb.dataset.addonPrice);
    });
    if (batteryCheckbox.checked && variant) addonTotal += variant.price;
    var formatted = '£' + ((basePrice + addonTotal) / 100).toFixed(2);
    priceEl.textContent = formatted;
    if (stickyPriceEl) stickyPriceEl.textContent = formatted;
    updateRPAmounts();
  });

  // MutationObserver — keeps installment amounts in sync with any price change
  var rpPriceEl = document.querySelector('[data-rp-price]');
  if (rpPriceEl) {
    new MutationObserver(function() { updateRPAmounts(); })
      .observe(rpPriceEl, { childList: true, subtree: true, characterData: true });
  }

  updateRPAmounts();
});

/* ===================== TRADE-IN QUOTE + MODAL ===================== */
var TRADE_VALUES = {
   'iPhone 11': {
    '64GB': { 'Excellent': 70, 'Good': 60, 'Fair': 50 },
    '128GB': { 'Excellent': 85, 'Good': 70, 'Fair': 60 },
    '256GB': { 'Excellent': 100, 'Good': 85, 'Fair': 70 }
  },
  'iPhone 11 Pro': {
    '64GB': { 'Excellent': 95, 'Good': 80, 'Fair': 65 },
    '256GB': { 'Excellent': 115, 'Good': 100, 'Fair': 80 },
    '512GB': { 'Excellent': 135, 'Good': 115, 'Fair': 105 }
  },
  'iPhone 11 Pro Max': {
    '64GB': { 'Excellent': 120, 'Good': 100, 'Fair': 80 },
    '256GB': { 'Excellent': 140, 'Good': 120, 'Fair': 105 },
    '512GB': { 'Excellent': 150, 'Good': 130, 'Fair': 110 }
  },
  'iPhone 12': {
    '64GB': { 'Excellent': 115, 'Good': 100, 'Fair': 80 },
    '128GB': { 'Excellent': 135, 'Good': 115, 'Fair': 90 },
    '256GB': { 'Excellent': 160, 'Good': 135, 'Fair': 100 }
  },
  'iPhone 12 Pro': {
    '128GB': { 'Excellent': 145, 'Good': 125, 'Fair': 110 },
    '256GB': { 'Excellent': 170, 'Good': 145, 'Fair': 120 },
    '512GB': { 'Excellent': 190, 'Good': 160, 'Fair': 125 }
  },
  'iPhone 12 Pro Max': {
    '128GB': { 'Excellent': 180, 'Good': 155, 'Fair': 130 },
    '256GB': { 'Excellent': 200, 'Good': 170, 'Fair': 135 },
    '512GB': { 'Excellent': 225, 'Good': 190, 'Fair': 140 }
  },
  'iPhone 13': {
    '128GB': { 'Excellent': 150, 'Good': 140, 'Fair': 130 },
    '256GB': { 'Excellent': 210, 'Good': 180, 'Fair': 135 },
    '512GB': { 'Excellent': 230, 'Good': 195, 'Fair': 140 }
  },
  'iPhone 13 Pro': {
    '128GB': { 'Excellent': 215, 'Good': 185, 'Fair': 170 },
    '256GB': { 'Excellent': 235, 'Good': 200, 'Fair': 175 },
    '512GB': { 'Excellent': 260, 'Good': 220, 'Fair': 180 }
  },
  'iPhone 13 Pro Max': {
    '128GB': { 'Excellent': 250, 'Good': 215, 'Fair': 120 },
    '256GB': { 'Excellent': 265, 'Good': 225, 'Fair': 125 },
    '512GB': { 'Excellent': 310, 'Good': 266, 'Fair': 125 }
  },
  'iPhone 14': {
    '128GB': { 'Excellent': 195, 'Good': 165, 'Fair': 130 },
    '256GB': { 'Excellent': 235, 'Good': 200, 'Fair': 130 },
    '512GB': { 'Excellent': 245, 'Good': 210, 'Fair': 135 }
  },
  'iPhone 14 Plus': {
    '128GB': { 'Excellent': 210, 'Good': 180, 'Fair': 100 },
    '256GB': { 'Excellent': 245, 'Good': 210, 'Fair': 105 },
    '512GB': { 'Excellent': 265, 'Good': 225, 'Fair': 110 }
  },
  'iPhone 14 Pro': {
    '128GB': { 'Excellent': 265, 'Good': 225, 'Fair': 120 },
    '256GB': { 'Excellent': 300, 'Good': 255, 'Fair': 125 },
    '512GB': { 'Excellent': 305, 'Good': 260, 'Fair': 130 }
  },
  'iPhone 14 Pro Max': {
    '128GB': { 'Excellent': 300, 'Good': 255, 'Fair': 125 },
    '256GB': { 'Excellent': 340, 'Good': 290, 'Fair': 130 },
    '512GB': { 'Excellent': 365, 'Good': 305, 'Fair': 135 }
  },
  'iPhone 15': {
    '128GB': { 'Excellent': 305, 'Good': 260, 'Fair': 130 },
    '256GB': { 'Excellent': 330, 'Good': 280, 'Fair': 135 },
    '512GB': { 'Excellent': 350, 'Good': 300, 'Fair': 140 }
  },
  'iPhone 15 Plus': {
    '128GB': { 'Excellent': 320, 'Good': 275, 'Fair': 145 },
    '256GB': { 'Excellent': 345, 'Good': 295, 'Fair': 150 },
    '512GB': { 'Excellent': 340, 'Good': 305, 'Fair': 150 }
  },
'iPhone 15 Pro': {
  '128GB': { 'Excellent': 355, 'Good': 305, 'Fair': 150 },
  '256GB': { 'Excellent': 395, 'Good': 335, 'Fair': 150 },
  '512GB': { 'Excellent': 410, 'Good': 350, 'Fair': 160 }
},
'iPhone 15 Pro Max': {
  '256GB': { 'Excellent': 420, 'Good': 340, 'Fair': 165 },
  '512GB': { 'Excellent': 470, 'Good': 400, 'Fair': 170 }
},
'iPhone 16': {
  '128GB': { 'Excellent': 390, 'Good': 330, 'Fair': 130 },
  '256GB': { 'Excellent': 455, 'Good': 390, 'Fair': 140 },
  '512GB': { 'Excellent': 480, 'Good': 410, 'Fair': 155 }
},
'iPhone 16 Plus': {
  '128GB': { 'Excellent': 400, 'Good': 340, 'Fair': 150 },
  '256GB': { 'Excellent': 435, 'Good': 370, 'Fair': 155 },
  '512GB': { 'Excellent': 480, 'Good': 410, 'Fair': 170 }
},
'iPhone 16 Pro': {
  '128GB': { 'Excellent': 520, 'Good': 445, 'Fair': 175 },
  '256GB': { 'Excellent': 550, 'Good': 470, 'Fair': 190 },
  '512GB': { 'Excellent': 575, 'Good': 490, 'Fair': 195 }
},
'iPhone 16 Pro Max': {
  '256GB': { 'Excellent': 590, 'Good': 500, 'Fair': 205 },
  '512GB': { 'Excellent': 670, 'Good': 570, 'Fair': 220 }
},
'iPhone 17': {
  '256GB': { 'Excellent': 495, 'Good': 420, 'Fair': 180 },
  '512GB': { 'Excellent': 535, 'Good': 395, 'Fair': 185 }
},
'iPhone 17 Air': {
  '256GB': { 'Excellent': 465, 'Good': 420, 'Fair': 190 },
  '512GB': { 'Excellent': 495, 'Good': 420, 'Fair': 120 }
},
'iPhone 17 Pro': {
  '256GB': { 'Excellent': 650, 'Good': 555, 'Fair': 210 },
  '512GB': { 'Excellent': 685, 'Good': 585, 'Fair': 190 }
},
'iPhone 17 Pro Max': {
  '256GB': { 'Excellent': 700, 'Good': 595, 'Fair': 220 },
  '512GB': { 'Excellent': 790, 'Good': 670, 'Fair': 245 }
}
};

document.addEventListener('change', function(e) {
  if (!e.target.closest('#rp-trade-modal')) return;
  var model     = document.getElementById('trade-model');
  var storage   = document.getElementById('trade-storage');
  var condition = document.getElementById('trade-condition');
  var valueEl   = document.getElementById('trade-value');
  var quoteBox  = document.getElementById('rp-trade-quote');
  if (!model || !storage || !condition || !valueEl) return;
  var entry = TRADE_VALUES[model.value];
  var val   = entry && entry[storage.value] && entry[storage.value][condition.value];
  valueEl.textContent = val ? '£' + val : 'Not available';
  if (quoteBox) quoteBox.style.display = val ? 'block' : 'none';
});

document.addEventListener('click', function(e) {
  if (!e.target.matches('#trade-continue')) return;

  var model     = document.getElementById('trade-model');
  var storage   = document.getElementById('trade-storage');
  var condition = document.getElementById('trade-condition');
  var valueEl   = document.getElementById('trade-value');
  if (!model || !storage || !condition || !valueEl) return;

  // Always calculate fresh on Continue click
  var entry = TRADE_VALUES[model.value];
  var val   = entry && entry[storage.value] && entry[storage.value][condition.value];
  var estimatedValue = val ? '£' + val : 'Not available';

  // Update the quote display too
  if (valueEl) valueEl.textContent = estimatedValue;

  var tradeText = model.value + ' / ' + storage.value + ' / ' + condition.value + ' / Est. value: ' + estimatedValue;

  // ... rest of your existing code unchanged


  var form = document.querySelector('.rp-form');
  if (form) {
    form.querySelectorAll('.trade-hidden-input').forEach(function(el) { el.remove(); });
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[Trade-in]';
    input.value = tradeText;
    input.className = 'trade-hidden-input';
    form.appendChild(input);
  }

  var tradeModal = document.getElementById('rp-trade-modal');
  if (tradeModal) tradeModal.classList.remove('is-open');

  var confirmText = document.getElementById('rp-trade-confirm-text');
  if (confirmText) {
    confirmText.innerHTML = 'Complete your trade-in and get <strong>' + estimatedValue + '</strong> after device inspection — that\'ll be like today\'s purchase setting you back less!';
  }

  var confirmModal = document.getElementById('rp-trade-confirm-modal');
  if (confirmModal) confirmModal.classList.add('is-open');
});

window.addEventListener('load', updateRPAmounts);
document.addEventListener('shopify:section:load', updateRPAmounts);

// Show quote for default dropdown values on modal open
document.addEventListener('change', function(e) {
  if (!e.target.closest('#rp-trade-modal')) return;
  var model     = document.getElementById('trade-model');
  var storage   = document.getElementById('trade-storage');
  var condition = document.getElementById('trade-condition');
  var valueEl   = document.getElementById('trade-value');
  var quoteBox  = document.getElementById('rp-trade-quote');
  var errorMsg  = document.getElementById('trade-in-error-msg'); // ← ADD THIS
  if (!model || !storage || !condition || !valueEl) return;
  var entry = TRADE_VALUES[model.value];
  var val   = entry && entry[storage.value] && entry[storage.value][condition.value];
  valueEl.textContent = val ? '£' + val : 'Not available';
  if (quoteBox) quoteBox.style.display = val ? 'block' : 'none';
  if (errorMsg) errorMsg.style.display = val ? 'none' : 'block'; // ← ADD THIS
});
  setTimeout(function() {
    var model     = document.getElementById('trade-model');
    var storage   = document.getElementById('trade-storage');
    var condition = document.getElementById('trade-condition');
    var valueEl   = document.getElementById('trade-value');
    var quoteBox  = document.getElementById('rp-trade-quote');
    var errorMsg  = document.getElementById('trade-in-error-msg'); // ← ADD THIS
    if (!model || !storage || !condition || !valueEl) return;
    var entry = TRADE_VALUES[model.value];
    var val   = entry && entry[storage.value] && entry[storage.value][condition.value];
    if (valueEl) valueEl.textContent = val ? '£' + val : 'Not available';
    if (quoteBox) quoteBox.style.display = val ? 'block' : 'none';
    if (errorMsg) errorMsg.style.display = val ? 'none' : 'block'; // ← ADD THIS
  }, 50);
